<template>
  <div class="progress-bar">
    <div class="progress" :style="{ width: progress + '%' }"></div>
    <div class="progress-text">{{ progress.toFixed(0) }}%</div>
  </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            required: true
        },
    }
}
</script>

<style scoped>

.progress-bar {
    width: 100%;
    height: 20px;
    background-color: #ddd;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
     margin-top: 40px;
}

.progress {
    height: 100%;
    background-color: #66dc71;
    transition: width 0.5s ease-in-out;
}

.progress-text {
    position: absolute;
    width: 100%;
    text-align: center;
    font-weight: bold;
    color: #333;
    top: 50%;
    transform: translateY(-50%);
}
</style>
